import { autoinject, newInstance } from 'aurelia-framework';
import { Router, RouterConfiguration, Redirect } from "aurelia-router";
import { applicationLogger } from "../../logging/logger";
import { AdminApi } from "../../services/admin-api";
import { MdToastService } from "aurelia-materialize-bridge";
import { User as ApplicationUser } from "oidc-client";
import { OpenIdConnect, OpenIdConnectRoles } from "aurelia-open-id-connect";

export abstract class Page {

    protected applicationUser: ApplicationUser;

    constructor(protected adminApi: AdminApi,
        protected toast: MdToastService,
        protected router: Router,
        protected openIdConnect: OpenIdConnect) {
        this.openIdConnect.observeUser((applicationUser: ApplicationUser) => this.onUserChanged(applicationUser));
    }

    private onUserChanged(applicationUser: ApplicationUser) {
        this.applicationUser = applicationUser;
    }

    get applicationUserIsLoggedIn() : boolean {
        return (this.applicationUser && !this.applicationUser.expired);
    }

    applicationUserIsInRole(role: string): boolean {
        return (this.applicationUser && this.applicationUser.profile.role.includes(role));
    }

    get applicationUserIsAdministrator() {
        return this.applicationUserIsGlobalAdministrator || this.applicationUserIsInRole("TenantAdministrator");
    }

    get applicationUserIsGlobalAdministrator() {
        return this.applicationUserIsInRole("GlobalAdministrator");
    }

    get applicationUserIsTenantAdministratorOnly() {
        return this.applicationUserIsInRole("TenantAdministrator") && ! this.applicationUserIsGlobalAdministrator;
    }
}